import { render } from "./landing_page.vue?vue&type=template&id=49ca55dc&scoped=true"
import script from "./landing_page.vue?vue&type=script&lang=js"
export * from "./landing_page.vue?vue&type=script&lang=js"

import "./landing_page.vue?vue&type=style&index=0&id=49ca55dc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ca55dc"]])

export default __exports__